import { useCustomProductOptionStore } from "store/custom-product-option/custom-product-option-shop.store";

export const useCustomProductOptionShopStoreActions = () => {
  return useCustomProductOptionStore(({ setFromProducts, reset }) => ({
    setFromProducts,
    reset,
  }));
};

export const useCustomProductOptionShopStoreState = () =>
  useCustomProductOptionStore(({ productConfigsBySupplier }) => ({
    productConfigsBySupplier,
  }));

export const useProductConfigs = (
  supplierCompanyId: string,
  productId: string
) =>
  useCustomProductOptionStore(
    ({ productConfigsBySupplier }) =>
      productConfigsBySupplier?.get(supplierCompanyId)?.get(productId)
        ?.configs ?? null
  );

export const useProductFiles = (supplierCompanyId: string, productId: string) =>
  useCustomProductOptionStore(
    ({ productConfigsBySupplier }) =>
      productConfigsBySupplier?.get(supplierCompanyId)?.get(productId)?.files ??
      []
  );
